import { ContourTexture } from '~/engine/data/structure/ContourTexture';
import { RegionOfInterest } from '~/engine/data/structure/RegionOfInterest';
import {
    BooleanOperation,
    SDFOperations,
} from '~/engine/util/algorithms/sdf/SDFOperations';
import { LayerBit } from '~/engine/view/layers/LayerBit';
import { ViewManager } from '~/engine/view/ViewManager';

const CROSS_SECTION_OPERATION = 'Cross-section reconstruction';

/**
 * Union `shape` onto the ROI as one undoable operation; only the voxels
 * under the shape are written.
 *
 * @returns true when the ROI took ownership of `shape` (empty-ROI path).
 */
export function applyShapeToRoi(
    roi: RegionOfInterest,
    shape: ContourTexture
): boolean {
    const texture = roi.texture;
    if (!texture || texture.isEmpty) {
        roi.replaceTexture(shape, CROSS_SECTION_OPERATION);
        ViewManager.invalidate(LayerBit.CONTOUR_LAYER_BIT);
        return true;
    }
    const modify = roi.startModify(CROSS_SECTION_OPERATION);
    try {
        SDFOperations.applyBoolean(texture, shape, BooleanOperation.OR, roi);
        modify.finish();
    } catch (error) {
        modify.cancel();
        throw error;
    } finally {
        ViewManager.invalidate(LayerBit.CONTOUR_LAYER_BIT);
    }
    return false;
}
